import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.1187 10.6187C16.4604 10.277 16.4604 9.72299 16.1187 9.38128C15.777 9.03957 15.223 9.03957 14.8813 9.38128L10.5 13.7626L9.11872 12.3813C8.77701 12.0396 8.22299 12.0396 7.88128 12.3813C7.53957 12.723 7.53957 13.277 7.88128 13.6187L9.88128 15.6187C10.223 15.9604 10.777 15.9604 11.1187 15.6187L16.1187 10.6187Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
